<template>
    <span class="u-icon">
        <img :class="imgClass" :src="imgPath" />
        <u-idle-timer v-if="showTimer" ref="timer"/>
    </span>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
    import UIdleTimer from '@/components/common/UIdleTimer.vue';

export default defineComponent({
    props: {
        image: String,
        showTimer: Boolean
    },
    components:{UIdleTimer},
    async setup(props) {
        const imgPath = await import(`@/assets/${props.image}.svg`);
        const imgClass = props.showTimer ? "img-timer" : "";
        const timer = ref(null);
        function resetCounter (){
            if(props.showTimer){
                Object(timer.value).resetCounter();
            }
        }
        return { imgPath: imgPath.default, imgClass, resetCounter, timer };
    },
})
</script>